const BAT_PREVIEW_MAX_WIDTH_PX = 800;
// The 2D canvas is sized in print pixels: one fabric unit is one pixel at this
// resolution. Anything measuring an effective resolution has to divide by it.
const CANVAS_DPI = 300;
const WARNING_MINIMUM_DPI = 150;

export { BAT_PREVIEW_MAX_WIDTH_PX, CANVAS_DPI, WARNING_MINIMUM_DPI };
